import React from 'react';
import './ced.css';
import {
  FaCarSide,
  FaBuilding,
  FaCogs,
  FaCouch,
  FaIndustry,
  FaScrewdriver,
  FaPaintRoller,
  FaSprayCan,
  FaTools,
  FaBolt,
} from 'react-icons/fa';
import img1 from '../../assets/images/front-headlamp-with-brilliant-reflections-body-car.jpg';

const floatingIcons = [FaSprayCan, FaPaintRoller, FaTools, FaBolt, FaIndustry];

const CEDCoatingOverview = () => {
  return (
    <section className="ced-container">
      {/* Floating Icons Background */}
      <div className="floating-icons">
        {[...Array(15)].map((_, i) => {
          const IconComponent = floatingIcons[i % floatingIcons.length];
          return (
            <div
              key={i}
              className="floating-icon"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${i * 1.5}s`,
              }}
            >
              <IconComponent />
            </div>
          );
        })}
      </div>

      {/* Heading */}
      <div className="ced-heading">
        <h2>CED COATING</h2>
        <p>
          The Cathodic Electro Deposition (CED) process is widely used in the automotive and other industries for better corrosion protection because of its ability to coat complex geometry parts with uniformity. It is not easily possible in Powder coating or spray painting. Nimbai Coating has been supporting various industries by providing CED Coating for Automobile Parts in New Delhi, helping to enhance product life with effective corrosion protection.
        </p>
      </div>

      {/* Main Content */}
      <div className="ced-content">
        <div className="ced-side left align-right">
          <CEDPoint icon={<FaCarSide />} title="Automobile Parts" />
          <CEDPoint icon={<FaBuilding />} title="Construction Material" />
          <CEDPoint icon={<FaCogs />} title="Sheet Metal Components" />
        </div>

        <div className="ced-image-wrapper">
          <img src={img1} alt="CED Coating" className="ced-image" loading="lazy" />
        </div>

        <div className="ced-side right align-left">
          <CEDPoint icon={<FaCouch />} title="Furniture & Accessories" />
          <CEDPoint icon={<FaIndustry />} title="Casting Products" />
          <CEDPoint icon={<FaScrewdriver />} title="Fasteners" />
        </div>
      </div>
    </section>
  );
};

const CEDPoint = ({ icon, title }) => (
  <div className="ced-point">
    <div className="ced-icon">{icon}</div>
    <h4>{title}</h4>
  </div>
);

export default CEDCoatingOverview;
